<template>
  <section>
    <div class="container mt-3" id="googleMaps">
      <div class="row">
        <div class="col-md-12 text-center">
          <h2 id="maptitle">Select A Service Center Near You</h2>
        </div>
        <div class="col-md-5">
          <div class="search">
            <label>
              <gmap-autocomplete
                @place_changed="setPlace"
                :placeholder="placeholder"
              >
              </gmap-autocomplete>
            </label>
            <select v-model="radius">
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="500">500</option>
            </select>
            <button type="button" class="btn" @click="updateLocations">Search</button>
          </div>
          <store-list :markers="markers"/>
        </div>
        <div class="col-md-7">
          <GmapMap
            :center="center"
            :zoom="zoom"
            map-type-id="terrain"
            ref="map"
          >
            <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
              <div class="info-window">
                <p><b>{{infoContent.name}}</b></p>
                <p>{{infoContent.address}}</p>
                <p>{{infoContent.city}}, {{infoContent.state}} {{infoContent.zip}}</p>
                <p>Phone: {{infoContent.phone}}</p>
                <!-- <p>Website: {{infoContent.website}}</p> -->

                <a :href="`${infoContent.website}`">Select</a>
              </div>
            </gmap-info-window>
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :position="m.position"
              :clickable="true"
              @click="toggleInfoWindow(m,i)"
            />
          </GmapMap>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import serviceCenters from '@/data/serviceCenters'
import StoreList from '@/components/StoreList'
export default {
  name: 'GoogleMap',
  components: {
    StoreList
  },

  data () {
    return {
      serviceCenters,
      center: {lat: 49.286483, lng: -123.112638},
      zoom: 10,
      infoContent: {},
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      place: null,
      radius: 100
    }
  },

  methods: {
    toggleInfoWindow (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },

    computeDistance () {
      this.markers.forEach(marker => {
        let center = new google.maps.LatLng(this.center)
        let targetLoc = new google.maps.LatLng(marker.position)
        let distance = google.maps.geometry.spherical.computeDistanceBetween(center, targetLoc)
        marker['distance'] = distance
      })
    },

    setPlace (place) {
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }
      this.place = place
      this.computeDistance()
    },

    convertRadius () {
      this.radius = Number(this.radius) * 1609.344
    },

    filterMarkers () {
      this.markers = this.markers.filter(marker => marker.distance < this.radius)
    },

    sortMarkers () {
      this.markers.sort((a, b) => a.distance - b.distance)
    },

    updateLocations () {
      this.convertRadius()

      // filter and sort markers
      this.filterMarkers()
      this.sortMarkers()

      // set map zoom higher for zoom in effect
      this.zoom = 12
    }
  },

  created () {
    this.serviceCenters.map(element => {
      this.markers.push(
        {
          position: {
            lat: Number(element.lat),
            lng: Number(element.lng)
          },
          infoText: {
            name: element.name,
            address: element.address,
            city: element.city,
            state: element.state,
            zip: element.zip_code,
            phone: element.phone_number,
            website: element.website
          }
        }
      )
    })
  }
}
</script>

<style scoped>
h1 {
  margin-bottom: 50px;
  text-align: center;
}

h2{
  font-size: 3rem;
  line-height: 1.6;
  color: #009579;

}

.btn{
  background-color: #009579;
  color: white;
}

.btn:hover{
  background-color: purple;
}
.info-window p {
  margin-bottom: 5px
}
.vue-map-container {
  display: inline-block;
  width: 100%;
  height: 550px;
}
.search {
  padding: 12px 0;
  text-align: center;
  background-color: #eee;
}
.search button {
  margin-left: 10px;
  padding: 2px .75rem;
}
label {
  padding-right: 10px;
  margin-bottom: 0;
}
select {
  height: 31px;
}

#googleMaps {
  min-height: 700px;
}

@media (max-width: 480px) {
#googleMaps {min-hight: 500px; max-width: 400px}
#maptitle{font-size: 1.5rem}
}

@media (min-width: 481px) and (max-width: 767px) {
#googleMaps {min-hight: 500px; max-width: 600px}
#maptitle{font-size: 2rem}

}

@media (min-width: 768px) and (max-width: 979px) {
#googleMaps {max-width: 700px;}
#maptitle{font-size: 2rem}

}


@media (min-width: 980px) and (max-width: 1399px) {
#googleMaps { min-width: 800px;}
#maptitle{font-size: 2.5rem}

}

@media (min-width: 1400px) {
#googleMaps {min-width: 1400px;}
#maptitle{font-size: 3rem}

}
</style>



// WEBPACK FOOTER //
// src/components/GoogleMapTwo.vue